import { Modal } from "components/ui";

export default function ImportPeriodWarningModal({
  cancelLabel,
  continueLabel,
  currentPeriodLabel,
  detailText,
  isLoading = false,
  onCancel,
  onContinue,
  periodName,
  show = false,
  title,
  warningText,
}) {
  return (
    <Modal
      open={show}
      loading={isLoading}
      title={title}
      cancelLabel={cancelLabel}
      okLabel={continueLabel}
      onClose={onCancel}
      onConfirm={onContinue}
      testIdPrefix="import-period-warning-"
    >
      <>
        <div className="mb-3 d-flex align-items-start">
          <div className="text-danger mr-2 mt-1">
            <i className="bi bi-exclamation-triangle-fill"></i>
          </div>
          <div>
            <div className="font-weight-bold">{warningText}</div>
            <div className="mt-2">
              <strong>{currentPeriodLabel}</strong>{' '}
              <span className="text-danger font-weight-bold">{periodName || '-'}</span>
            </div>
          </div>
        </div>
        <div className="mb-0 text-muted">{detailText}</div>
      </>
    </Modal>
  );
}
